import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { XeroTenant } from 'src/app/models';
import { XeroFeedConnection } from 'src/app/models/xero.model';
import { XeroBankFeedService } from 'src/app/shared/services/xero-bank-feed.service';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-xero-feed-connections',
  templateUrl: './xero-feed-connections.component.html',
  styleUrls: ['./xero-feed-connections.component.scss'],
})
export class XeroFeedConnectionsComponent implements OnInit {
  @Input() tenant: XeroTenant;

  feedConnections: XeroFeedConnection[] = [];
  isLoading = false;

  constructor(
    protected dialogRef: NbDialogRef<XeroFeedConnectionsComponent>,
    private bankFeed: XeroBankFeedService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
  ) {}

  async ngOnInit() {
    await this.loadFeedConnections();
  }

  async loadFeedConnections() {
    try {
      this.isLoading = true;
      this.feedConnections = await this.bankFeed.getFeedConnections(this.tenant.tenantId);
    } catch (error) {
      console.error('Error loading feed connections:', error);
      this.toastrService.danger('Failed to load feed connections', 'Error');
    } finally {
      this.isLoading = false;
    }
  }

  async deleteFeedConnection(connection: XeroFeedConnection) {
    const dialog = this.dialogService.open(DialogComponent, {
      context: {
        title: 'Delete Feed Connection',
        body: `Delete feed connection for ${connection.accountName}?`,
        confirm: 'Delete',
        status: 'danger',
      },
    });

    const result = await dialog.onClose.toPromise();
    if (result !== 'confirm') return;

    try {
      this.isLoading = true;
      await this.bankFeed.deleteFeedConnection(this.tenant.tenantId, connection.id);
      await this.loadFeedConnections();
      this.toastrService.success('Feed connection deleted', 'Success');
    } catch (error) {
      console.error('Error deleting feed connection:', error);
      this.toastrService.danger('Failed to delete feed connection', 'Error');
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.dialogRef.close();
  }
}
